import { SET } from '../';
import { GiftCardService } from '@/services';

export default {
	namespaced: true,
	state: {
		deliveryOptions: [],
		personalMessages: [],
		wrappingOptions: []
	},
	mutations: {
		SET
	},
	actions: {
		async getDeliveryOptions({ commit }) {
			const deliveryOptions = await GiftCardService.GetGiftCardDeliveryOptions();
			if (deliveryOptions) {
				commit('SET', { key: 'deliveryOptions', value: deliveryOptions });
			}

			return deliveryOptions;
		},
		async getPersonalMessages({ commit }) {
			const personalMessages = await GiftCardService.GetGiftCardPersonalMessages();
			if (personalMessages) {
				commit('SET', { key: 'personalMessages', value: personalMessages });
			}

			return personalMessages;
		},

		async getWrappingOptions({ commit }) {
			const wrappingOptions = await GiftCardService.GetGiftCardWrappingOptions();
			if (wrappingOptions) {
				commit('SET', { key: 'wrappingOptions', value: wrappingOptions });
			}

			return wrappingOptions;
		}
	}
};
